import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import {
  Button,
  FormatText,
  FormDatePicker,
  FormInput,
  FormItem,
  FormSubmitButton,
  FormTextArea,
  MasterDetailForm,
  Upload,
  Widget,
} from '@digital/ui';
import { UploadFile } from '@app/components';
import { hasPermission } from '@app/helpers/permissions';
import CurrencyInput from '@app/components/CurrencyInput';

import { updateDadosCobranca, urlDownloadArquivo } from '@app/api/autorizacaoPagamento/autorizacao';

import './modal.css';

export interface PropsModalAnexarArquivoAutorizacao {
  autorizacaoId: string;
  autorizacaoData: any;
  setUpdate: any;
}

const ModalAnexarArquivoAutorizacao = (props: PropsModalAnexarArquivoAutorizacao) => {
  const { autorizacaoId, setUpdate, autorizacaoData } = props;
  const [exibirModal, setExibirModal] = useState(false);

  const handleSubmit = values => {
    values.textoValor = formatReal(values.valor);
    updateDadosCobranca(values.formData, values, autorizacaoId).then(data => {
      if (data.valid) {
        setExibirModal(false);
        setUpdate(null);
        setUpdate(true);
      }
    });
  };

  const formatReal = (valor: string) => {
    let tmp = valor + '';
    tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
    tmp = tmp.replace('.,', ',');
    if (tmp.length > 6) {
      tmp = tmp.replace(/(\d)(?=(\d{3})+\,)/g, '$1.');
    }
    return tmp;
  };

  return (
    <>
      <Button
        onClick={() => {
          setExibirModal(true);
          // CarregarDados();
        }}>
        {' '}
        ANEXAR DOCUMENTO DE COBRANÇA
      </Button>
      <Modal
        title="Anexos"
        // className="chat-modal"
        width="1200px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formModal"
          onSubmit={handleSubmit}
          actions={[
            <Button
              type="link"
              onClick={() => {
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <FormSubmitButton
              noIcon={true}
              type="primary"
              disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR'])}>
              <FormatText id="ui.commons.save" uppercase />
            </FormSubmitButton>,
          ]}>
          <Widget>
            <FormInput name="documentoCobrancaNumero" label="Número do Documento" span={4} />
            <FormDatePicker name="dataEmissao" label="Data de Emissão" format="DD/MM/YYYY" span={4} />
            <CurrencyInput defaultValue={0} name="valor" label="Valor" span={4} />
            <UploadFile
              hasFile={autorizacaoData.nomeArquivo ? true : false}
              url={
                urlDownloadArquivo +
                autorizacaoData.localArquivo +
                '\\' +
                autorizacaoData.nomeArquivo +
                '&fileName=' +
                autorizacaoData.nomeArquivo}
                nameFormData={'file'}
                idDoComponente={'file'}
              />
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};
export default ModalAnexarArquivoAutorizacao;
